import React from 'react'

const Error = ({ errorMsg, errorStyle }) => {
    return (
        <div className='error_screen'>
            {errorStyle && errorStyle.background ? <div className="error_msg" style={errorStyle}>{errorMsg}</div> : <div className="error_msg">{errorMsg}</div>}
        </div>
    )
}

export default Error